<div>
  <bw-action-article-legacy [brightsideWebFb]="{ event_name: 'maintenance' }">
    <div pre-title>
      <img class="mb-sm" src="../assets/warning-cone.png" />
    </div>
    <div header-title>
      <typography-legacy title-large color="var(--primary-text)">
        <span [innerHTML]="'MAINTENANCE_TITLE' | translate"></span>
      </typography-legacy>
    </div>
    <div content-section>
      <bw-paragraph-legacy>{{ 'MAINTENANCE_DESC' | translate }}</bw-paragraph-legacy>
    </div>
    <div footer-actions class="flex-row flex-item-flexible space-between">
      <button bw-button-legacy type="submit" [brightsideWebFb]="{ event_name: 'maintenance' }" (click)="goHome()">
        {{ 'CLOSE' | translate }}
      </button>
    </div>
  </bw-action-article-legacy>
</div>
